import React,{useEffect, useState}  from "react";
import {   Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
useDisclosure,
FormControl,
FormLabel,
Button,
Input,
Flex,
Alert,
AlertDescription,
AlertIcon,
AlertTitle} from "@chakra-ui/react";
 
import "./popup.css"
import { useLocation, useNavigate } from "react-router";
function Popup(){
    function InitialFocus() {
        const { isOpen, onOpen, onClose } = useDisclosure()
        const [amount, setAmount] = useState(1500)
      
        const initialRef = React.useRef(null)
        const finalRef = React.useRef(null)
       
        function getAmount(val){
            setAmount(val.target.value)
      }
      const navigate = useNavigate();
        function alt(){
            navigate("/payment",{replace:true})
      }
      const location = useLocation();
      const prevPath = location?.state?.from?.pathname || "/"
      console.log(prevPath)
      const close = () => {
        return navigate(prevPath,{replace:true})
      }
      useEffect(()=>{onOpen()},[])
        return (
            <div >
          <>
            <Modal
            blockScrollOnMount={false}
              initialFocusRef={initialRef}
              finalFocusRef={finalRef}
              isOpen={isOpen}
              onClose={onClose}
            >
              <ModalOverlay />
              <ModalContent  className="popup">
                <ModalHeader bg="#01bfbd" color="#fff">Choose a donation amount</ModalHeader>
                <p>Most Donors donate approx 1500 to this Fundraiser</p>
                  <ModalCloseButton onClick={close} color='black' />
                <Flex  className="popup"  >
                <Button onClick={()=>setAmount(1000)} bg="#01bfbd" colorScheme='blue'  color="#fff" mr={3}>
                    1000
                  </Button>
                  <Button onClick={()=>setAmount(1500)} bg="#01bfbd" colorScheme='blue' color="#fff" mr={3}>
                    1500
                  </Button>
                  <Button onClick={()=>setAmount(4500)} bg="#01bfbd" colorScheme='blue' color="#fff" mr={3}>
                    4500
                  </Button>
                </Flex>
                <ModalBody pb={3}>
                <FormControl mt={2}>
                    <FormLabel>Other Amount</FormLabel>
                    <Input type='number' onChange={getAmount} placeholder='Enter Other Amount' />
                  </FormControl>
                </ModalBody>
                <ModalBody pb={6}>
                  <FormControl>
                    <FormLabel>Name</FormLabel>
                    <Input ref={initialRef} placeholder='Name' />
                  </FormControl>
      
                  <FormControl mt={4}>
                    <FormLabel>Email</FormLabel>
                    <Input placeholder='Email' />
                  </FormControl>
                  <FormControl mt={4}>
                    <FormLabel>Your Mobile number</FormLabel>
                    <Input placeholder='Your Mobile number' />
                  </FormControl>
                </ModalBody>
      
                <ModalFooter  >
                    <div className="popup">
                  <Button bg="#01bfbd" color="#fff" onClick={alt} colorScheme='blue' mr={3}>
                    Proceed To Pay {amount}
                  </Button>
                  <Button bg="#01bfbd" color="#fff" onClick={onClose} colorScheme='blue'>Cancel</Button>
                  </div>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </>
          </div>
        )
        
      }
    return(
        <div  >
      <InitialFocus/>
        </div>
    )
}
export default Popup;